export const quiz =  {
    "questions": [
      {
        "question": "How can you access the state of a component from inside of a member function?",
        "answerSelectionType": "radio",
        "answers": [
          "this.getState()",
          "this.prototype.stateValue",
          "this.state",
          "this.values"
        ],
      },
      {
        "question": "ReactJS is developed by _____ Engineers?",
        "answerSelectionType": "input",
        "rightAnswers": [
          "Google Engineers",
          "Facebook Engineers"
        ],
       },
      {
        "question": "ReactJS is an MVC based framework?",
        "answerSelectionType": "radio",
        "answers": [
          "True",
          "False"
        ],
      },
      {
        "question": "Which of the following concepts is/are key to ReactJS?",
        "answerSelectionType": "select",
        "answers": [
          "Component-oriented design",
          "Event delegation model",
          "Both of the above",
        ],
      },
      {
        "question": "What are the advantages of React JS?",
        "answerSelectionType": "checkbox",
        "answers": [
          "React can be used on client and as well as server side too",
          "Using React increases readability and makes maintainability easier. Component, Data patterns improves readability and thus makes it easier for manitaining larger apps",
          "React components have lifecycle events that fall into State/Property Updates",
          "React can be used with any other framework (Backbone.js, Angular.js) as it is only a view layer"
        ],
      },
    ],
    "rightAnswers": {
      "'1'": "3",
      "'2'": "facebook",
      "'3'": "2",
      "'4'": "3",
      "'5'": [1, 2, 4]
    },
  } 